import datePreviousMonth from '../../../procedures/date-previous-month';
import column from '../../abstract/column';
import form from '../../abstract/form';
import vars from '../../abstract/vars';
import actions from './actions';
import api, { modelName } from './api';

export default {
  actions,
  topRightActions: {
    create: {
      label: 'Dodaj paczkę',
      icon: 'icon-plus',
      handle: async ({ $router }) => await $router.push('/zus-packages/add'),
    },
  },
  api,
  modelName,
  sidebarData: {
    id: column({
      label: 'Identyfikator',
      size: 100
    }),
  },
  columns: {
    year: column({
      label: 'Rok',
      form: form({
        render: false,
        transformIf: ({ data: { _period } }) => _period,
        transform: undefined,
        reverseTransform: ({ data: { _period } }) => _period.getFullYear(),
      }),
    }),
    month: column({
      label: 'Miesiąc',
      form: form({
        render: false,
        transformIf: ({ data: { _period } }) => _period,
        transform: undefined,
        reverseTransform: ({ data: { _period } }) => _period.getMonth() + 1,
      }),
    }),
    _period: column({
      label: 'Okres',
      grid: false,
      sidebar: false,
      dateFormat: 'yyyy-MM',
      form: form({
        transformIf: ({ item: { year, month } }) => year && month,
        transform: ({ item: { year, month } }) => new Date(year, month - 1, 1),
        reverseTransform: undefined,
      }),
    }),
    created_at: column({
      label: 'Data dodania',
    }),
  },
  vars: vars({
    noItemsText: 'Brak zestawów',
    sidebarLabel: 'Podgląd zestawu',
    initItem: () => {
      const previousMonth = datePreviousMonth();

      return {
        year: previousMonth.getFullYear(),
        month: previousMonth.getMonth() + 1,
      };
    },
    onSuccessSave: async ({ $router }) => await $router.push('/zus-packages'),
  }),
};
